module.exports = __webpack_public_path__ + "img/light_1.a8839161.png";